import React from 'react';
import DefaultButton from 'components/Button';
import { Box } from '@material-ui/core';
import { useIntl } from 'react-intl';
import NextButton from './nextButton';

const DesktopFooter = (props: {
  isLoading: boolean;
  isLoadingParams: boolean;
  setStep: (step: number) => void;
  getStep: number;
}) => {
  const intl = useIntl();
  return (
    <>
      <Box
        component="span"
        m={1}
        style={{
          margin: 0,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '32px',
          paddingBottom: '32px',
          paddingRight: '80px',
          paddingLeft: '80px',
        }}
      >
        <DefaultButton
          onClick={
            /* istanbul ignore next */ () => {
              props.setStep(props.getStep - 1);
            }
          }
          backgroundColor={'#979797'}
          style={{ width: 70 }}
          disabled={props.getStep === 0}
        >
          {intl.formatMessage({ id: 'dmo.footer.previous' })}
        </DefaultButton>
        <NextButton
          isLoading={props.isLoading}
          isLoadingParams={props.isLoadingParams}
          isComplementaryForm={props.getStep === 2}
        />
      </Box>
    </>
  );
};

export default DesktopFooter;
